import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SUPPORT_CONTACTS = [
  { name: 'Primary Support', number: '9809034879', type: 'WhatsApp/Call' },
];

const Footer = () => {
  const [showSupportModal, setShowSupportModal] = useState(false);
  const currentYear = new Date().getFullYear();

  const navGroups = [
    {
      title: 'Platform',
      links: [
        { to: '/', label: 'Home' },
        { to: '/requests', label: 'Blood Requests' },
        { to: '/stars', label: 'Leaderboard' },
        { to: '/request-blood', label: 'Request Blood' },
      ],
    },
    {
      title: 'Donors',
      links: [
        { to: '/donor-registration', label: 'Become a Donor' },
        { to: '/profile', label: 'My Profile' },
        { to: '/my-requests', label: 'My Requests' },
        { to: '/login', label: 'Sign In' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { to: '/privacy', label: 'Privacy Policy' },
        { to: '/terms', label: 'Terms of Service' },
      ],
    },
  ];

  return (
    <>
      <footer className="bg-surface-950 text-white mt-auto">
        {/* Top gradient bar */}
        <div className="h-1 bg-crimson-gradient" />

        <div className="section-container pt-14 pb-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
            {/* Brand */}
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center gap-3 mb-5 group">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-crimson-gradient shadow-glow-sm group-hover:shadow-glow transition-all">
                  <span className="text-xl">🩸</span>
                </div>
                <div>
                  <div className="font-bold text-white text-base leading-tight" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                    OCYM Blood Donors Network
                  </div>
                  <div className="text-surface-500 text-xs">Kerala's Blood Donation Platform</div>
                </div>
              </Link>
              <p className="text-surface-400 text-sm leading-relaxed mb-6 max-w-xs">
                The Orthodox Christian Youth Movement's initiative to connect blood donors with those in need across Kerala. 
                Every donation saves up to three lives.
              </p>

              {/* Contact buttons */}
              <div className="flex flex-wrap gap-2">
                <button
                  onClick={() => setShowSupportModal(true)}
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-surface-800 text-surface-300 text-sm hover:bg-surface-700 hover:text-white transition-all"
                >
                  📞 Support
                </button>
                <a
                  href={`https://wa.me/919809034879?text=Hi, I need help with OCYM Blood Donors App`}
                  target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-green-900/50 text-green-400 text-sm hover:bg-green-800/60 hover:text-green-300 transition-all"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                  WhatsApp
                </a>
                <a
                  href="https://ocymonline.org/"
                  target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-surface-800 text-surface-300 text-sm hover:bg-surface-700 hover:text-white transition-all"
                >
                  🌐 OCYM
                </a>
              </div>
            </div>

            {/* Nav groups */}
            {navGroups.map(group => (
              <div key={group.title}>
                <h4 className="text-xs font-bold text-surface-400 uppercase tracking-widest mb-4">{group.title}</h4>
                <ul className="space-y-3">
                  {group.links.map(({ to, label }) => (
                    <li key={to}>
                      <Link to={to} className="text-sm text-surface-400 hover:text-white transition-colors">
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom bar */}
          <div className="border-t border-surface-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-surface-500 text-sm">
              © {currentYear} OCYM Blood Donors Network. All rights reserved.
            </p>
            <p className="text-surface-600 text-xs">
              Built with ❤️ for the people of Kerala
            </p>
          </div>
        </div>
      </footer>

      {/* ── Support Modal ── */}
      {showSupportModal && (
        <div className="modal-overlay" onClick={() => setShowSupportModal(false)}>
          <div className="modal-panel max-w-sm" onClick={e => e.stopPropagation()}>
            <div className="p-6 border-b border-surface-100">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-surface-900" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>Contact Support</h3>
                <button
                  onClick={() => setShowSupportModal(false)}
                  className="w-8 h-8 rounded-full bg-surface-100 flex items-center justify-center text-surface-500 hover:bg-surface-200 transition-colors"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <p className="text-sm text-surface-500 mt-1">Our support team is here to help</p>
            </div>

            <div className="p-6 space-y-3">
              {SUPPORT_CONTACTS.map((contact, i) => (
                <div key={i} className="rounded-xl bg-surface-50 border border-surface-100 p-4">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-sm font-semibold text-surface-800">{contact.name}</span>
                    <span className="badge-neutral text-xs">{contact.type}</span>
                  </div>
                  <div className="text-2xl font-black text-surface-800 mb-3">📞 {contact.number}</div>
                  <div className="grid grid-cols-2 gap-2">
                    <a href={`tel:${contact.number}`}
                      className="btn btn-secondary btn-sm text-xs">
                      Call
                    </a>
                    <a href={`https://wa.me/91${contact.number}?text=Hi, I need help with OCYM Blood Donors App`}
                      target="_blank" rel="noopener noreferrer"
                      className="btn btn-success btn-sm text-xs">
                      WhatsApp
                    </a>
                  </div>
                </div>
              ))}

              <div className="flex items-center gap-3 p-4 rounded-xl bg-sky-50 border border-sky-100">
                <span className="text-xl">✉️</span>
                <div>
                  <div className="text-xs text-sky-600 font-medium mb-0.5">Email Support</div>
                  <a href="mailto:support@ocymblood.org" className="text-sm text-sky-700 font-semibold hover:underline">
                    support@ocymblood.org
                  </a>
                </div>
              </div>

              <button
                onClick={() => setShowSupportModal(false)}
                className="btn btn-ghost btn-md w-full border border-surface-200"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
